"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var React = require("react");
var Pages_1 = require("@/rendering/common/Pages");
var MegaMenuAction_1 = require("@/pages/common/actions/MegaMenuAction");
var classNames = require("classnames");
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var MegaMenuSearchPopup_1 = require("@/pages/common/components/MegaMenuSearchPopup");
var LanguageSwitcher_1 = require("@/components/LanguageSwitcher");
var MegaMenuV2_1 = require("./MegaMenuV2");
var WindowApi_1 = require("@/api/browser/WindowApi");
var mapStateToProps = function (state, ownProps) {
    var _a;
    return (__assign(__assign({}, state.layout), { userName: state.user.firstname ? state.user.firstname : state.user.email, userId: state.user.id || "", userFrom: state.user.from || "", userEmail: state.user.email || "", isNotConfirmed: !state.user.isConfirmed, hideAlert: state.page === Pages_1.Pages.CONFIRM_EMAIL_REGISTER ? true : false, showFav: state.page === Pages_1.Pages.SEARCH, page: state.page, lang: state.layout.language.languages
            .filter(function (it) { return it.id === state.layout.language.current; })[0]
            .code1.toLowerCase(), langShort: state.layout.language.languages
            .filter(function (it) { return it.id !== state.layout.language.current; })[0]
            .shortName.toUpperCase(), currencyShort: state.layout.currencies.options.filter(function (it) { return it.key === state.layout.currencies.currentCurrencyId; })[0].symbol, t: state.translate, hideSettings: ownProps ? ownProps.hideSettings : false, tel: state.layout.offices[0].telephone, nobottom: ownProps && ownProps.nobottom ? ownProps.nobottom : false, nosearch: ownProps && ownProps.nosearch ? ownProps.nosearch : false, isMobile: state.mobile || false, linkCareers: state.layout.careerUrl, pendingDocumentCount: state.user.id && state.side
            ? (_a = state.side.items
                .find(function (it) {
                return it.children &&
                    it.children.find(function (it2) { return it2.page === Pages_1.Pages.PENDING_DOCUMENT; });
            })) === null || _a === void 0 ? void 0 : _a.children.find(function (it) { return it.page === Pages_1.Pages.PENDING_DOCUMENT; }).count : 0 }));
};
var mapDispatchToProps = function (dispatch) { return ({
    onMegaMenuLeave: function () { return dispatch(MegaMenuAction_1.default.setAllPopupsActive(false)); },
    onBuySelected: function () { return dispatch(MegaMenuAction_1.default.setBuyPopupActive(true)); },
    onBuyHover: function () { return dispatch(MegaMenuAction_1.default.onBuyHover()); },
    onBuyToggle: function () { return dispatch(MegaMenuAction_1.default.onBuyToggle()); },
    onRentSelected: function () { return dispatch(MegaMenuAction_1.default.setRentPopupActive(true)); },
    onRentHover: function () { return dispatch(MegaMenuAction_1.default.onRentHover()); },
    onRentToggle: function () { return dispatch(MegaMenuAction_1.default.onRentToggle()); },
    onAgentSelected: function () { return dispatch(MegaMenuAction_1.default.setAgentPopupActive(true)); },
    onAgentHover: function () { return dispatch(MegaMenuAction_1.default.onAgentHover()); },
    onAgentToggle: function () { return dispatch(MegaMenuAction_1.default.onAgentToggle()); },
    onResourcesSelected: function () {
        return dispatch(MegaMenuAction_1.default.setResourcesPopupActive(true));
    },
    onResourcesHover: function () { return dispatch(MegaMenuAction_1.default.onResourcesHover()); },
    onResourcesToggle: function () { return dispatch(MegaMenuAction_1.default.onResourcesToggle()); },
    onAboutUsSelected: function () { return dispatch(MegaMenuAction_1.default.setAboutUsPopupActive(true)); },
    onAboutUsHover: function () { return dispatch(MegaMenuAction_1.default.onAboutUsHover()); },
    onAboutUsToggle: function () { return dispatch(MegaMenuAction_1.default.onAboutUsToggle()); },
    onLanguageEnter: function () { return dispatch(MegaMenuAction_1.default.onLanguageEnter()); },
    onLanguageToggle: function () { return dispatch(MegaMenuAction_1.default.onLanguageToggle()); },
    onMobileTopMenuClick: function () { return dispatch(MegaMenuAction_1.default.onMobileTopMenuClick()); },
    onMobileBack: function () { return dispatch(MegaMenuAction_1.default.onMobileBack()); },
    onMobileResourceBack: function () { return dispatch(MegaMenuAction_1.default.onMobileResourceBack()); },
    onAccountMenuToggle: function () { return dispatch(MegaMenuAction_1.default.onAccountMenuToggle()); },
    onFavoriteMenuToggle: function () { return dispatch(MegaMenuAction_1.default.onFavoriteMenuToggle()); },
    onMobileLangToggle: function () { return dispatch(MegaMenuAction_1.default.onMobileLangToggle()); },
    onBuyPopularDistrictToggle: function () {
        return dispatch(MegaMenuAction_1.default.onBuyPopularDistrictToggle());
    },
    onBuyPopularBuildingToggle: function () {
        return dispatch(MegaMenuAction_1.default.onBuyPopularBuildingToggle());
    },
    onRentPopularDistrictToggle: function () {
        return dispatch(MegaMenuAction_1.default.onRentPopularDistrictToggle());
    },
    onRentPopularBuildingToggle: function () {
        return dispatch(MegaMenuAction_1.default.onRentPopularBuildingToggle());
    },
    onLoginClicked: function () { return dispatch(MegaMenuAction_1.default.onLoginClicked()); },
    onLogoutClicked: function () { return dispatch(MegaMenuAction_1.default.onLogoutClicked()); },
    onMyAccountClick: function () { return dispatch(MegaMenuAction_1.default.onMyAccountClick()); },
    onFavoriteClick: function () { return dispatch(MegaMenuAction_1.default.onFavoriteClick()); },
    onSetLanguage: function (language) {
        return dispatch(LayoutAction_1.default.onSetLanguage(language));
    },
    onSearchIconClick: function () { return dispatch(MegaMenuAction_1.default.onSearchIconClick()); },
    onCallClick: function () { return dispatch(MegaMenuAction_1.default.onCallClick()); },
    onEmailClick: function () { return dispatch(MegaMenuAction_1.default.onEmailClick()); },
    onResourceForSaleClicked: function () {
        return dispatch(MegaMenuAction_1.default.onResourceForSaleClicked());
    },
    onResourceForRentClicked: function () {
        return dispatch(MegaMenuAction_1.default.onResourceForRentClicked());
    },
    onMobileResourcePopularDistrictsClicked: function () {
        return dispatch(MegaMenuAction_1.default.onMobileResourcePopularDistrictsClicked());
    },
    onMobileResourcePopularBuildingsClicked: function () {
        return dispatch(MegaMenuAction_1.default.onMobileResourcePopularBuildingsClicked());
    },
    onMobileResourceForSaleClick: function () {
        return dispatch(MegaMenuAction_1.default.onMobileResourceForSaleClick());
    },
    onMobileResourceForRentClick: function () {
        return dispatch(MegaMenuAction_1.default.onMobileResourceForRentClick());
    },
}); };
var megaMenuComponent = function (props) {
    var t = props.tMegamenu;
    var megamenu = props.megamenu;
    var currentLang = props.lang;
    var displayName = props.userName || props.userEmail;
    var isUnverified = props.isNotConfirmed;
    var megaBodyClass = classNames([
        "l-mega__body",
        {
            "l-mega__body--active": megamenu.mobileMenuActive,
            "l-mega__body--sub-active": megamenu.buyPopupActive ||
                megamenu.rentPopupActive ||
                megamenu.agentPopupActive ||
                megamenu.resourcesPopupActive ||
                megamenu.aboutUsPopupActive,
        },
    ]);
    var accountClass = classNames([
        "c-mega__account",
        "c-mega__li",
        { "c-mega__account--active": megamenu.accountActive },
    ]);
    var favoriteClass = classNames([
        "c-mega__favorite",
        "c-mega__li",
        { "c-mega__favorite--active": megamenu.favoriteActive },
    ]);
    var megaClass = classNames([
        "l-mega",
        {
            "l-mega--with-bottom": !props.nobottom,
            "l-mega--nosearch": props.nosearch,
        },
    ]);
    var userAlertClass = megamenu.isUserAlert ? "c-mega__account--alert" : "";
    var setLanguage = function (language) {
        var selectedLanguage = props.language.languages.find(function (it) { return it.id === language; });
        if (selectedLanguage)
            return function () { return props.onSetLanguage(selectedLanguage); };
        return function () { };
    };
    var renderLocationItem = function (item, i) {
        return (React.createElement("li", { key: i },
            React.createElement("a", { href: WindowApi_1.toAbsoluteUrl(item.url) },
                React.createElement("span", null, item.name),
                item.image ? (React.createElement("div", null,
                    React.createElement("img", { "data-lazy": "manual", "data-src": item.image, alt: item.name }))) : null)));
    };
    var renderLocationItemNoImage = function (item, i) {
        return (React.createElement("li", { key: i },
            React.createElement("a", { href: WindowApi_1.toAbsoluteUrl(item.url) }, item.name)));
    };
    return (React.createElement("div", { className: megaClass },
        React.createElement("div", { className: "l-mega__top c-mega__top " + (megamenu.mobileMenuActive ? "l-mega__top--active" : "") },
            React.createElement("div", { className: "c-mega__top-menu" },
                React.createElement("a", { onClick: props.onMobileTopMenuClick },
                    React.createElement("span", { className: "fal fa-bars " + (props.pendingDocumentCount ? "c-mega__account--alert" : "") }),
                    React.createElement("span", { className: "fal fa-times" }))),
            React.createElement("div", { className: "c-mega__top-logo" },
                React.createElement("a", { href: WindowApi_1.toAbsoluteUrl("/" + currentLang) },
                    React.createElement("img", { id: "okay-forbes-logo-550", alt: "OKAY.COM | Founding member of Forbes Global Properties", src: WindowApi_1.toAbsoluteUrl("/res/img/okay-logo-sm2.png") }))),
            React.createElement("div", { className: "c-mega__top-search" },
                React.createElement("a", { onClick: props.onSearchIconClick },
                    React.createElement("span", { className: "fal fa-search" })))),
        React.createElement("div", { className: megaBodyClass },
            React.createElement("div", { className: "l-mega__container" },
                React.createElement(MegaMenuV2_1.default, null),
                React.createElement("div", { className: "l-mega__logo" },
                    React.createElement("div", { className: "c-mega__logo" },
                        React.createElement("a", { href: WindowApi_1.toAbsoluteUrl("/" + currentLang) },
                            React.createElement("img", { id: "okay-forbes-logo", alt: "OKAY.COM | Founding member of Forbes Global Properties", src: WindowApi_1.toAbsoluteUrl("/res/img/okay-logo-fgp.png") })))),
                React.createElement("div", { className: "l-mega__settings" },
                    React.createElement("nav", { className: "c-mega" },
                        React.createElement("ul", { className: "c-mega__settings" },
                            React.createElement("li", { className: accountClass },
                                React.createElement("a", { onClick: props.onMyAccountClick },
                                    React.createElement("span", { className: "far fa-user-circle " + userAlertClass }),
                                    displayName ? (React.createElement("span", { className: "c-mega__name" },
                                        displayName,
                                        isUnverified ? " - " + t.unverified : "")) : null,
                                    React.createElement("span", { className: "c-mega__text" }, t.myAccount)),
                                displayName && !isUnverified ? (React.createElement("ul", null,
                                    React.createElement("li", null,
                                        React.createElement("a", { href: WindowApi_1.toAbsoluteUrl("/" + currentLang + "/profile/accountinfo") }, t.personalDetails)),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: WindowApi_1.toAbsoluteUrl("/" + currentLang + "/mydocument/pendingdocument") },
                                            t.pendingDocument,
                                            props.pendingDocumentCount
                                                ? " (" + props.pendingDocumentCount + ")"
                                                : "")),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: WindowApi_1.toAbsoluteUrl("/" + currentLang + "/mydocument/signeddocument") }, t.signedDocument)),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: WindowApi_1.toAbsoluteUrl("/" + currentLang + "/myproperty/mylistings") }, t.mylisting)),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: WindowApi_1.toAbsoluteUrl("/" + currentLang + "/myproperty/myviewings") }, t.myviewing)),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: WindowApi_1.toAbsoluteUrl("/" + currentLang + "/profile/changepassword") }, t.changePassword)),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: WindowApi_1.toAbsoluteUrl("/" + currentLang + "/profile/alerts") }, t.alerts)),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: WindowApi_1.toAbsoluteUrl("/" + currentLang + "/profile/locations") }, t.myplaces)),
                                    React.createElement("li", null,
                                        React.createElement("a", { onClick: props.onLogoutClicked }, t.logout)))) : null,
                                displayName && isUnverified ? (React.createElement("ul", null,
                                    React.createElement("li", null,
                                        React.createElement("a", { href: WindowApi_1.toAbsoluteUrl("/" + currentLang + "/account/resendverification") }, t.unverified)),
                                    React.createElement("li", null,
                                        React.createElement("a", { onClick: props.onLogoutClicked }, t.logout)))) : null,
                                !displayName ? (React.createElement("ul", null,
                                    React.createElement("li", null,
                                        React.createElement("a", { onClick: props.onLoginClicked }, t.signIn)),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: WindowApi_1.toAbsoluteUrl("/" + currentLang + "/account/register") }, t.createAccount)))) : null),
                            React.createElement("li", { className: favoriteClass },
                                React.createElement("a", { onClick: props.onFavoriteClick },
                                    React.createElement("span", { className: "far fa-heart" }),
                                    React.createElement("span", { className: "c-mega__text" }, t.favorite)),
                                React.createElement("ul", null,
                                    React.createElement("li", null,
                                        React.createElement("a", { href: WindowApi_1.toAbsoluteUrl("/" + currentLang + "/profile/savedproperties") }, t.savedProperties)),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: WindowApi_1.toAbsoluteUrl("/" + currentLang + "/profile/savedsearch") }, t.savedSearches)),
                                    React.createElement("li", null,
                                        React.createElement("a", { href: WindowApi_1.toAbsoluteUrl("/" + currentLang + "/profile/recentlyviewed") }, t.recentlyViewed))))))),
                React.createElement(LanguageSwitcher_1.default, { setLanguage: setLanguage, currentLang: currentLang, options: props.language.languages }),
                React.createElement("div", { className: "l-mega__search c-mega c-mega__search" },
                    React.createElement("a", { onClick: props.onSearchIconClick },
                        React.createElement("span", { className: "far fa-search" }))))),
        React.createElement(MegaMenuSearchPopup_1.default, null)));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(megaMenuComponent);
